<template>
    <v-list-tile v-if="seasonTotal">
        <v-list-tile-content class="LocationDataLabels">Since Season Start ({{ seasonTotal.SeasonStartDate || 'N/A' }}):</v-list-tile-content>
        <v-list-tile-content v-if="loading">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </v-list-tile-content>
        <v-list-tile-content v-else class="align-end">{{ formatAmount(seasonTotal.TotalDerivedTonnes) }} Tonnes, {{ formatAmount(seasonTotal.TonnesPerHa) }} Tonnes / ha</v-list-tile-content>
    </v-list-tile>
</template>
<script>
import locationApi from '@/api/locationApi'

export default {
    props: {
        locationID: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            seasonTotal: {}
        }
    },
    methods: {
        async loadTotal() {
            this.loading = true;

            this.seasonTotal = await locationApi.getSeasonTotal(this.locationID);
            
            this.loading = false;
        },
        formatAmount(v) {
            if (v > 0) {
                return Math.round(v * 10000) / 10000
            }

            return 'N/A'
        }
    },
    async mounted() {
        await this.loadTotal();
    }
}
</script>